<template>
  <div id="chartChinaMap" style="height:600px;width:800px;"></div>
</template>

<script>
let Highcharts = require('highcharts/highmaps');
import chinaMapData from '@/plugins/chinaMap';
import { getAreaUser } from '@/plugins/api';
export default {
  data () {
    return { chartData: [], max: 0 }
  },
  methods: {
    getDefaultOption () {
      return {
        title: { text: null },
        credits: { enabled: false },
        tooltip: { headerFormat: '' },
        colorAxis: {
          min: 1,
          stops: [[0, '#E0F2F1'], [1, '#004D40']],
          max: this.max,
        },
        series: [{
          data: this.chartData, mapData: chinaMapData, joinBy: 'name',
          dataLabels: {
            enabled: true,
            style: { fontSize: '9px' },
            formatter: function () {
              if (this.point.value > 0) return `${this.point.name}(${this.point.value})`
              return `<span style='color:#BDBDBD;'>${this.point.name}</span>`
            }
          }
        }]
      }
    },
    init () {
      this.initAreaUser();
    },

    initAreaUser () {
      getAreaUser().then(res => {
        let d = res.data || {}, data = [];
        for (let k in d) {
          let v = d[k];
          if (v > this.max) this.max = v;
          data.push({ name: k, value: v })
        }
        this.max = parseInt(this.max * 10);
        this.chartData = data;
        Highcharts.Map('chartChinaMap', this.getDefaultOption());
      })
    }
  },
  mounted () {
    this.init();
  }
}
</script>